import { Column, ModelBase } from 'loca-boot-core'
import { AresPermissionModel, AresConditionModel } from './Ares.model'

// 租户数据模型
export class LesseeModel extends ModelBase {
  // 租户code
  @Column()
  public lesseeCode!: string

  // 租户名称
  @Column()
  public lesseeName!: string
}

export class ConditionTypeModel extends ModelBase {
  @Column()
  public type!: string

  @Column()
  public isAll!: boolean
}

export class UserInfoModel extends ModelBase {
  @Column({ default: '' }) // 同邮箱前缀
  public userId!: string

  @Column({ default: '' }) // 名字
  public name!: string

  @Column({ default: '' }) // 邮箱
  public email!: string

  @Column({ default: '' }) // 手机号
  public mobile!: string

  @Column({ default: '' }) // 当前租户code
  public lesseeCode!: string

  @Column({ default: '' }) // 当前租户名称
  public lesseeName!: string
}

export class UserModel extends ModelBase {
  @Column({ default: '' }) // 同邮箱前缀
  public userId!: number

  @Column({ default: '' }) // 当前租户code
  public curLesseeCode!: string

  @Column({ default: '' }) // 当前租户名称
  public curLesseeName!: string

  @Column({ childType: UserInfoModel })
  public userInfo!: UserInfoModel

  @Column({ childType: AresPermissionModel, autowired: true })
  public aresPermissionList!: AresPermissionModel[]

  @Column({ childType: AresConditionModel, autowired: true })
  public aresConditionList!: AresConditionModel[]

  @Column({ childType: ConditionTypeModel, autowired: true })
  public conditionTypes!: ConditionTypeModel[]

  @Column({ childType: LesseeModel, autowired: true })
  public lessees!: LesseeModel[]
}
